import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getOrderItems, GetOrderItemsParams} from '../api';
import {QUERY__ORDER_ITEMS} from '../queryKeys';
import {OrderItem} from '../types';

export const useGetOrderItems = <SelectedData = GetListOutput<OrderItem>>(
  params: GetOrderItemsParams,
  options?: QueryOptionsForList<OrderItem, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__ORDER_ITEMS, params],
    queryFn: () => getOrderItems(params),
    ...options,
  });
};
